"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ElementPositionArray = exports.ElementTagArray = exports.ElementSizesArray = void 0;
// Element size
var ElementSizesArray = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
exports.ElementSizesArray = ElementSizesArray;
// Element tag
var ElementTagArray = ['p', 'div', 'span', 'b', 'strong', 'em', 'i']; // Element position

exports.ElementTagArray = ElementTagArray;
var ElementPositionArray = ['left', 'center', 'right'];
exports.ElementPositionArray = ElementPositionArray;